import { ArrowUpRight, CheckCircle } from 'lucide-react';
import workingconstructor from '@/assets/constructorworking.jpg';
import { useNavigate } from 'react-router-dom';
export const QaulityService = () => {
  let navigate = useNavigate();
  return (
    <div className="flex w-full justify-center bg-[white] py-[4rem] font-inter">
      <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[3rem] gap-y-[3rem] px-[2rem]">
        <div className="flex w-full flex-wrap items-start gap-[2rem] md:w-[50%]">
          <div className="w-full">
            <h1 className="text-center text-[2.4rem] font-[700] leading-[4rem] text-[#121212] sm:text-left md:text-[3.2rem] lg:text-[4rem] lg:leading-[5.5rem]">
              From Groundworks to Finishes We Build with Precision
            </h1>
            {/* <div className="mt-[3rem] flex w-full flex-wrap items-stretch justify-between gap-y-[1rem]">
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/maintenance.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />{' '}
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Building Maintenance</p>
                </div>
              </div>
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/landscaping.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Gardening & Landscaping</p>
                </div>
              </div>
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/plumbing.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />{' '}
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Plumbing</p>
                </div>
              </div>
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/painting.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />{' '}
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Painting</p>
                </div>
              </div>
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/electricalwork.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />{' '}
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Electrical Work</p>
                </div>
              </div>
              <div className="flex w-full items-start justify-between rounded-[1rem] lg:w-[48%]">
                <img
                  alt="service provided"
                  src={'/cleaning.png'}
                  className="mt-[0.3rem] h-auto w-[2.5rem] text-[#e24e1f] lg:w-[3rem]"
                />{' '}
                <div className="w-[calc(100%-5rem)]">
                  <p className="text-[2rem] font-[600] text-[#666666]">Cleaning</p>
                </div>
              </div>
            </div> */}
            <p className="mt-[2rem] text-[1.6rem] font-[400] leading-[3.2rem] text-[#666666]">
              From the ground up, we handle every part of your build or refurbishment with care and
              precision. Our trusted teams work across homes and properties throughout the UK,
              combining skilled craftsmanship with a reliable, hands-on approach that delivers
              lasting quality
            </p>
            <div className="mt-[2rem] flex w-full flex-col gap-y-[1rem]">
              <div className="flex items-center justify-start gap-[1rem]">
                <CheckCircle className="mt-[0.3rem] h-auto w-[2rem] text-[#e24e1f]" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400] leading-[105%] text-[#121212]">
                  Expertly delivering projects from concept to completion — with precision, speed,
                  and skill.{' '}
                </p>
              </div>
              <div className="flex items-center justify-start gap-[1rem]">
                <CheckCircle className="mt-[0.3rem] h-auto w-[2rem] text-[#e24e1f]" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400] leading-[105%] text-[#121212]">
                  Modern methods. Superior materials. Long-lasting results.
                </p>
              </div>
              <div className="flex items-center justify-start gap-[1rem]">
                <CheckCircle className="mt-[0.3rem] h-auto w-[2rem] text-[#e24e1f]" />
                <p className="w-[calc(100%-3rem)] text-[1.6rem] font-[400] leading-[105%] text-[#121212]">
                  Deliver on time and within budget — every single project.
                </p>
              </div>
            </div>
            <div
              onClick={() => navigate('/contact-us')}
              className="mt-[2rem] flex justify-start gap-[0.5rem]"
            >
              <h1 className="text-[1.6rem] font-[600] leading-[3.2rem] text-[#666666] underline">
                Get A Free Quote
              </h1>
              <ArrowUpRight className="inline-block h-auto w-[2rem] text-[#e24e1f] underline" />
            </div>
          </div>
        </div>
        <div className="w-full max-w-[40rem] rounded-md text-center md:w-[50%] md:text-start">
          <img
            alt="service provided"
            className="h-full w-auto rounded-md object-cover"
            src={workingconstructor}
          />
        </div>
      </div>
    </div>
  );
};
